import React from "react";
import ReactDOM from "react-dom/client";
import Root from "./strukturku/Root";
import { AuthProvider } from "./strukturku/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Root />
    </AuthProvider>
  </React.StrictMode>
);
